import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const submit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
            toast.success("E-mail envoyé");
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="max-w-md mx-auto px-5 md:px-10 py-16 md:py-24" data-testid="forgot-page">
            <p className="bc-label-small">Récupération</p>
            <h1 className="font-serif text-[#D4BC7C] text-4xl sm:text-5xl mt-4">Mot de passe oublié</h1>
            <div className="bc-hairline-gold my-6" />

            {!sent ? (
                <>
                    <p className="text-[#F2ECE0]/80 text-sm">
                        Entrez votre adresse e-mail. Si un compte y est associé, vous recevrez un lien pour
                        réinitialiser votre mot de passe.
                    </p>
                    <form onSubmit={submit} className="mt-10 space-y-6" data-testid="forgot-form">
                        <div>
                            <label className="bc-label">E-mail</label>
                            <input
                                type="email"
                                required
                                className="bc-input"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                data-testid="forgot-email"
                            />
                        </div>
                        {error && (
                            <div
                                className="border px-4 py-3 text-sm"
                                style={{ borderColor: "rgba(217,112,112,0.6)", color: "#ffb0b0", background: "#1a0a0a" }}
                                data-testid="forgot-error"
                            >
                                {error}
                            </div>
                        )}
                        <button className="bc-btn w-full" disabled={loading} data-testid="forgot-submit">
                            {loading ? "Envoi..." : "Envoyer le lien"}
                        </button>
                    </form>
                </>
            ) : (
                <div data-testid="forgot-success">
                    <div
                        className="border px-5 py-4 text-sm"
                        style={{ borderColor: "var(--bc-gold)", color: "#F2ECE0", background: "#0a0a0a" }}
                    >
                        Si un compte correspond à cette adresse, un e-mail contenant les instructions de réinitialisation vient d'être envoyé.
                    </div>
                    <Link to="/connexion" className="bc-btn mt-8 inline-flex" data-testid="forgot-back">
                        Retour à la connexion
                    </Link>
                </div>
            )}
        </section>
    );
}
